import _ from "lodash";
import ACTIONS from "../actions/BillingOrganizationsActions";
import {BillingOrgSortFields} from "../constants/BillingOrganizationsActionConstants";
import SortDirection from "../../../common/constants/SortDirection";
import {listPageGlobalFilter} from "../../../common/utils/FilterFunctions";

const initialState = {
    billing_organizations: [],
    filtered_billing_organizations: [],
    updatedOrg: false,
    enableCPModal: false,
    organizationDetail: {},
    organizationAddress: [],
    organizationBilling: {},
    organizationTenants: [],
    billingOrgSortKey: BillingOrgSortFields.NAME,
    billingOrgSortDirection: SortDirection.ASC,
    orgTenantsCountries: [],
    orgTenantsCountriesLoading: false,
    orgTenantsCountriesError: false,
}

const organizationsReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.BillingOrganizationsActionTypes.BILLING_ORG_GLOBAL_SEARCH: {
            let newState = _.cloneDeep(state);
            newState.filtered_billing_organizations = listPageGlobalFilter(action.payload,
                newState.billing_organizations);

            return newState;
        }

        case ACTIONS.BillingOrganizationsActionTypes.TOGGLE_BILLING_ORG_SORT: {
            let newState = _.cloneDeep(state);
            newState.billingOrgSortKey = action.payload;
            newState.billingOrgSortDirection = newState.billingOrgSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;
            if (newState.billingOrgSortDirection === SortDirection.ASC) {
                newState.filtered_billing_organizations = _.sortBy(newState.filtered_billing_organizations,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]);
            } else {
                newState.filtered_billing_organizations = _.sortBy(newState.filtered_billing_organizations,
                    [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
            }
            return newState;
        }


        case ACTIONS.BillingOrganizationsActionTypes.SET_BILLING_ORGANIZATIONS: {
            let newState = _.cloneDeep(state);
            newState.billing_organizations = action.payload;
            newState.filtered_billing_organizations = action.payload;
            return newState;
        }


        case ACTIONS.BillingOrganizationsActionTypes.SET_ORGANIZATION_DETAIL: {
            let newState = _.cloneDeep(state);
            newState.organizationDetail = action.payload.orgDetail.OrgDetail;
            newState.organizationAddress = action.payload.orgDetail.OrgAddress;
            newState.organizationBilling = action.payload.orgDetail.OrgBilling;
            newState.organizationTenants = action.payload.orgDetail.OrgTenants;
            return newState;
        }

        case ACTIONS.BillingOrganizationsActionTypes.UPDATED_ORG_REFRESH: {
            let newState = _.cloneDeep(state);
            newState.updatedOrg = !newState.updatedOrg;
            return newState;
        }

        case ACTIONS.BillingOrganizationsActionTypes.CLEAR_BILLING_DETAILS: {
            return initialState;
        }

        case ACTIONS.addEditBillingOrgActionTypes.TOGGLE_ENABLE_CP_MODAL: {
            let newState = _.cloneDeep(state);
            newState.enableCPModal = !newState.enableCPModal;
            return newState;
        }

        case ACTIONS.orgTenantsCountriesActionTypes.SET_ORG_TENANTS_COUNTRIES_LOADING: {
            let newState = _.cloneDeep(state);
            newState.orgTenantsCountries = [];
            newState.orgTenantsCountriesLoading = true;
            newState.orgTenantsCountriesError = false;
            return newState;
        }

        case ACTIONS.orgTenantsCountriesActionTypes.SET_ORG_TENANTS_COUNTRIES: {
            let newState = _.cloneDeep(state);
            newState.orgTenantsCountries = action.payload;
            newState.orgTenantsCountriesLoading = false;
            newState.orgTenantsCountriesError = false;
            return newState;
        }

        case ACTIONS.orgTenantsCountriesActionTypes.SET_ORG_TENANTS_COUNTRIES_ERROR: {
            let newState = _.cloneDeep(state);
            newState.orgTenantsCountries = [];
            newState.orgTenantsCountriesLoading = false;
            newState.orgTenantsCountriesError = true;
            return newState;
        }

        default:
            return state;
    }
}

export default organizationsReducer
